import { LoaderFunctionArgs } from "react-router-dom";
import { networkCall } from "../../../../../util/network-call/network-call";

export const AdminEducationEditLoader = async (args: LoaderFunctionArgs) => {

    const getEducationResponse = await networkCall(`/educations/${ args.params.id }`);

    return { getEducationResponse, id: args.params.id };

};